import React, { useEffect, useState } from 'react';
import client from 'utils/client';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import AppDataGrid from 'components/AppDataGrid/AppDataGrid';
import { ActivePill } from 'components/StatusPill/StatusPill';
import './merchant.css';
import { Link } from 'react-router-dom';
import { useToast } from 'components/Toast/useToast';
import usePagination from 'hooks/usePagination';

function Merchants() {
  let navigate = useNavigate();
  const { onOpen } = useToast();
  const [totalCount, setTotalCount] = React.useState(0);

  const [loading, setLoading] = useState(false);
  const [merchants, setMerchants] = useState([]);

  const {
    paginationData: { currentPage, pageSize },
    handlePageChange,
    handlePageSizeChange,
  } = usePagination();

  useEffect(() => {
    setLoading(true);
    client
      .get(`/merchants?page=${currentPage}&pageSize=${pageSize}`)
      .then((response) => {
        setMerchants(() => response.data.data);
        setTotalCount(response?.data?.pagination?.totalCount);
      })
      .catch((error) => onOpen({ type: 'error', message: error?.message || 'An error Occured' }))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize]);

  const renderDetailsButton = (params) => (
    <button
      type='button'
      className='btn-secondary'
      onClick={() => navigate(`/merchants/${params.row.id}`)}>
      View
    </button>
  );

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
      sortable: false,
      valueGetter: (p) => `${p.row.first_name || ''} ${p.row.last_name || ''}`.trim(),
    },
    { field: 'email', headerName: 'Email', width: 220 },
    { field: 'phone_number', headerName: 'Phone', width: 140, cellClassName: 'cell-mono' },
    { field: 'account_number', headerName: 'Account Number', width: 150, cellClassName: 'cell-mono' },
    { field: 'state', headerName: 'State', width: 130 },
    {
      field: 'active',
      headerName: 'Status',
      width: 110,
      renderCell: (p) => <ActivePill active={p.row.active} />,
    },
    {
      field: 'created_at',
      headerName: 'Created',
      width: 180,
      valueGetter: (p) => dayjs(p.row.created_at).format('MMM DD, YYYY h:mma'),
    },
    {
      field: 'actions',
      headerName: '',
      width: 90,
      sortable: false,
      filterable: false,
      align: 'right',
      headerAlign: 'right',
      renderCell: renderDetailsButton,
    },
  ];

  return (
    <>
      <div className='merchant'>
        <div className='merchant-title-container'>
          <h1 className='merchant-title'>Merchants</h1>
          <Link to='/new-merchant'>
            <button className='merchant-add-button'>Create</button>
          </Link>
        </div>
        <AppDataGrid
          className='merchants-list'
          pagination
          rows={merchants}
          columns={columns}
          page={currentPage - 1}
          pageSize={pageSize}
          rowCount={totalCount}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          loading={loading}
          paginationMode='server'
        />
      </div>
    </>
  );
}

export default Merchants;
